<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4>
        <v-date-picker
          v-model="fromDate"
        >
          <v-text-field
            box
            slot-scope='props'
            label="From"
            v-model='props.inputValue'
            append-icon="mdi-calendar-range"
            readonly
          >
          </v-text-field>
        </v-date-picker>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <v-date-picker
          v-model="toDate"
        >
          <v-text-field
            box
            slot-scope='props'
            label="To"
            v-model='props.inputValue'
            append-icon="mdi-calendar-range"
            readonly
          >
          </v-text-field>
        </v-date-picker>
      </v-flex>
      <v-flex xs12 sm6 md4>
        <div class="text-xs-center">
          <v-btn 
            color="pipefishOrange"
            outline
            class="elevation-1"
            @click="getEntriesForReport"
          >
            Apply Dates
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 sm6 md4 lg4>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="Search"
          color="pipefishGreen"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs3 md1>
        <div class="text-xs-center">
          <v-checkbox v-model="zh_checked" :label="`Filter Zero Hours`" id="zero-hrs-filter" />
        </div>
      </v-flex>
      <v-flex xs3 md2>
        <div class="text-xs-center">
          <v-checkbox v-model="active_checked" :label="`Filter Inactive Users`" id="active-filter" />
        </div>
      </v-flex>
      <v-flex xs6 md4>
        <div class="text-xs-center">
          <v-btn
          color="pipefishGreen"
          @click="exportCsv"
        >
          Export ALL to CSV
        </v-btn>
        
          <v-btn
            outline
            color="pipefishGreen"
            @click="exportFilteredCsv"
          >
            Export filtered to CSV
          </v-btn>
        </div>
      </v-flex>
      
      <v-flex xs12>
          <v-data-table
            ref="reportsTable"
            :headers="headers"
            :items="timesheetEntries"
            :search="search"
            class="elevation-1"
            sort-icon="mdi-menu-down"
            hide-actions
          >
            <template v-slot:items="props">
              <tr :class="{
                approvedHighlight: props.item.Approval == 'approved',
                notApprovedHighlight: props.item.Approval == 'not approved',
                pendingApprovalHighlight: props.item.Approval == 'pending approval'
                }">
                <td> {{props.item.Who}} </td>
                <td> {{props.item.Date}} </td>
                <td> {{props.item["Day Of Week"]}} </td>
                <td> {{props.item["Client Name"]}} </td>
                <td> {{props.item["Pipefish Practice"]}} </td>
                <td> {{props.item["Activity Code"]}} </td>
                <td> {{props.item["Activity Notes"]}} </td>
                <td> {{props.item.Project}} </td>
                <td> {{props.item.Hours}} </td>
                <td> {{props.item["SoW Name"]}} </td>
                <td> {{props.item.Units}} </td>
                <td> {{props.item["Billing Method"]}} </td>
                <td> {{props.item["Billing Calculation Method"]}} </td>
                <td class="text-capitalize"> {{props.item.Approval}} </td>
              </tr>
              
            </template>
          </v-data-table>
      </v-flex>
      <!-- <v-flex>
        <v-btn
          color="pipefishGreen"
          @click="exportCsv"
        >
          Export to CSV
        </v-btn>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import papa from 'papaparse'
import {
  mapState,
  mapMutations,
  mapActions
} from 'vuex'

function getDate(date, isDay) {

  return isDay ? new moment(date).format("dddd") : new moment(date).format("DD/MM/YYYY")
}

export default {
  data: () => ({
    zh_checked: false,
    active_checked: false,
    search: '',
    fromDate: new Date(),
    toDate: new Date(),
    headers: [
      {text: 'Who', value: 'Who'},
      {text: 'Date', value: 'Date'},
      {text: 'Day of Week', value: 'Day of Week'},
      {text: 'Client Name', value: 'Client Name'},
      {text: 'Pipefish Practice', value: 'Pipefish Practice'},
      {text: 'Activity Code', value: 'Activity Code'},
      {text: 'Activity Notes', value: 'Activity Notes'},
      {text: 'Project', value: 'Project'},
      {text: 'Hours', value: 'Hours'},
      {text: 'SoW Name', value: 'SoW Name'},
      {text: 'Units', value: 'Units'},
      {text: 'Billing Method', value: 'Billing Method'},
      {text: 'Cost Calculation', value: 'Billing Calculation Method'},
      {text: 'Approval', value: 'Approval'},
      {text: 'UserId', value: 'UserId', class: 'hidden'}
    ],
    timesheetEntries: [],
    originalTimeSheetEntries: [],
    activeUsers: []
  }),
  computed: {
    ...mapState('admin', ['pipefishUsers'])
  },
  created() {
    var self = this
    if(this.pipefishUsers.length == 0) {
      this.$timesheetApi.getAllUsers().then(response => {
        self.setSortedPipefishUsers(response)
      })
    }
  },
  methods: {
    ...mapActions('admin', ['setSortedPipefishUsers']),
    getEntriesForReport() {
      var self = this
      this.timesheetEntries = []
      var start = moment(this.fromDate)//.format("YYYY/MM/DD")
      var end = moment(this.toDate)//.format("YYYY/MM/DD")
      
      /* Get all dates within the selected Time frame  */
      var dates = {}
      dates[start.startOf('day').format('DD-MM-YYYY')] = {
        users: {},
        actualDate: start
      }
      var currDate = moment(start).startOf('day');
      var lastDate = moment(end).startOf('day');

      while(currDate.add(1, 'days').diff(lastDate) < 0) {
          dates[currDate.clone().format('DD-MM-YYYY')] = {
            users: {},
            actualDate: currDate.clone()
          }
      }
      if(!start.isSame(end, 'day')) {
        dates[end.format('DD-MM-YYYY')] = {
          users: {},
          actualDate: end
        }
      }

      for(var date in dates) {
        this.pipefishUsers.forEach(user => {
          dates[date].users[`user_${user.id}`] = {
            entries: [],
            name: `${user.GivenName} ${user.Surname}`
          }
        })
      }

      this.$timesheetApi.getAllTimesheetEntries(start.format("YYYY/MM/DD"), end.format("YYYY/MM/DD")).then(entries => {
        entries.forEach(entry => {
          var entryDate = moment(entry.WorkedOn).format('DD-MM-YYYY')
          var users = dates[entryDate].users // object with key as user
          users[`user_${entry.UserAccountId}`].entries.push(entry)
          // push the entry to the correct date under correct user

        })

        for(var date in dates) {
          // for each date
          for(var user in dates[date].users) {
            var singleUser = dates[date].users[user]
            var tableRow = {}
            if(singleUser.entries.length == 0) {
              // No entry for this date
              tableRow = {
                Who: singleUser.name,
                Date: getDate(dates[date].actualDate, false),
                "Day Of Week": getDate(dates[date].actualDate, true),
                // "Onsite or Not Onsite": '-',
                "Client Name": '-',
                "Pipefish Practice": '-',
                "Activity Code": '-',
                "Activity Notes" : '-',
                Project: '-',
                Hours: 0,
                "SoW Name" : '-',
                Units: '-',
                "Billing Method": '-',
                "Billing Calculation Method": '-',
                Approval: '-',
                UserId: singleUser.UserAccountId
              }
              this.timesheetEntries.push(tableRow)
            } else {
              var isActive = singleUser.entries[0].me.IsActive;
              console.log(isActive);
              var id = user.split('_')[1];
              if(self.activeUsers.indexOf(id) == -1 && isActive) {
                self.activeUsers.push(id);
              }
              
              //there is an entry(ies) for this date
              singleUser.entries.forEach(ent => {
                // for each entry on a date
                tableRow = {
                  Who: singleUser.name,
                  Date: getDate(dates[date].actualDate, false),
                  "Day Of Week": getDate(ent.WorkedOn, true),
                  "Client Name": ent.client.Name,
                  "Pipefish Practice": ent.practice.Name,
                  "Activity Code": ent.activity.Name,
                  "Activity Notes" : ent.Notes,
                  Project: ent.project.Name,
                  Hours: ent.HoursWorked,
                  "SoW Name" : ent.StatementName,
                  Units: '-',
                  "Billing Method": ent.statement.BillingMethod,
                  "Billing Calculation Method": ent.statement.CostCalculationMethod,
                  Approval: ent.approval ? ent.approval.Status : 'not approved',
                  UserId: id
                }
                this.timesheetEntries.push(tableRow)
              })
            }
          }
        }
        if(self.zh_checked || self.active_checked) {
          self.originalTimeSheetEntries = self.timesheetEntries;
          self.filterTimesheets(true);
        }
      })
    },
    getName(id){
      for(var i in data.users) {
        if(id == data.users[i].Id) {
          return data.users[i].GivenName + ' ' + data.users[i].Surname
        }
      }
    },
    exportCsv(){
      var csv = papa.unparse(this.timesheetEntries)
      const blob = new Blob([csv], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents'),
      a = document.createElement('a');
      a.download = "report.csv";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ['text/csv', a.download, a.href].join(':');
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    },
    exportFilteredCsv() {
      var csv = papa.unparse(this.$refs.reportsTable.filteredItems)
      const blob = new Blob([csv], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents'),
      a = document.createElement('a');
      a.download = "report.csv";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ['text/csv', a.download, a.href].join(':');
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    },
    test() {
      // console.log(this.$refs.reportsTable.filteredItems)
    },
    filterTimesheets(n) {
      var self = this;
      if(self.originalTimeSheetEntries.length == 0) {
        self.originalTimeSheetEntries = self.timesheetEntries;
      }
      var temp = self.timesheetEntries;
      if(self.zh_checked) {
        temp = temp.filter(obj => {
          return n ? obj.Hours > 0 : true
        })
      }
      if(self.active_checked) {
        temp = temp.filter(obj => {
          if(!n) {
            return true;
          } else {
            if(typeof obj.UserId == 'undefined') { return false; }
            return self.activeUsers.indexOf(obj.UserId) > -1
          }
        })
      }
      if(n) {
        self.timesheetEntries = temp
      } else {
        self.timesheetEntries = self.originalTimeSheetEntries
      }
    }
  },
  watch: {
    active_checked: function(n, o) {
      this.filterTimesheets(n);
    },
    zh_checked: function(n, o) {
      this.filterTimesheets(n);
    }
  }
}
</script>

<style>
.approvedHighlight {
  background-color: #e5ffe5
}

.notApprovedHighlight {
  background-color: #ffe5e5
}

.pendingApprovalHighlight {
  background-color: #ffffe5
}

.hidden {
  display: none;
}
</style>
